import { createAction, props } from '@ngrx/store';

import {
  RestSharedInspectionSpaceCategory,
  RestSpaceTemplateModel,
} from '../models/rest-space-template-model.interface';

/* Templates List */
export const loadAllSpaceTemplates = createAction('[SpaceTemplate] Load all space template');
export const loadAllSpaceTemplatesSuccess = createAction(
  '[SpaceTemplate] All space template loaded successfully',
  props<{ listItems: RestSpaceTemplateModel[] }>()
);
export const loadAllSpaceTemplatesFailed = createAction('[SpaceTemplate] All space template loading failed');

/* Add new space template */
export const createNewSpaceTemplate = createAction(
  '[SpaceTemplate] Add new space template',
  props<{ entityDetails: RestSpaceTemplateModel }>()
);
export const updateSpaceTemplateDetails = createAction(
  '[SpaceTemplate] Update new space template',
  props<{ entityDetails: RestSpaceTemplateModel }>()
);
export const updateSpaceTemplateDetailsFailed = createAction('[SpaceTemplate] Update space template failed');

/* Delete space template */
export const deleteSpaceTemplate = createAction('[SpaceTemplate] Remove space template', props<{ id: number }>());
export const clearSpaceTemplateData = createAction('[SpaceTemplate] Clear space template data');

/* Load categories */
export const loadAllCategories = createAction('[SpaceTemplate] Load unit types of exact property');
export const loadAllCategoriesSuccess = createAction(
  '[SpaceTemplate] All unit types loaded successfully',
  props<{ categoriesList: RestSharedInspectionSpaceCategory[] }>()
);
export const loadAllCategoriesFailed = createAction('[SpaceTemplate] All unit types loading failed');
